var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcnNftnerds = function SvgIcnNftnerds(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m10.479 7.602 2.341 1.345v2.93L7.23 15.088l-5.592-3.211v-2.93L7.23 5.736l1.655.947.637-.366L7.23 5 1 8.581v3.662l6.229 3.58 6.232-3.58V8.581l-2.345-1.345-.637.366Z",
    fill: "#595959"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.771 5 6.54 8.581v3.662l2.345 1.345.637-.366-2.341-1.345v-2.93l5.591-3.211 5.592 3.211v2.93l-5.592 3.211-1.655-.947-.637.366 2.292 1.317L19 12.243V8.581L12.771 5Z",
    fill: "#595959"
  })));
};
export default SvgIcnNftnerds;